// extracted by mini-css-extract-plugin
module.exports = {"news":"news_news__zJ3Kj","title":"news_title__3r1Ft","newsWrap":"news_newsWrap__REur0","loadMoreBtn":"news_loadMoreBtn__36zhr"};